import React from 'react';
import { useTranslation } from 'react-i18next';
import Accordion from '@common/ui/accordion/Accordion';
import OrderHistoryItem from './OrderHistoryItem';
const OrdersListForReturn = (props) => {
    var _a;
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "orders-listing--cs" }, ((_a = props === null || props === void 0 ? void 0 : props.orders) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement(Accordion, null, props.orders.map((order) => (
        // TODO - Check with <OrderReturnsItem /> ---------------------
        React.createElement(OrderHistoryItem, { key: order.orderNumber, order: order, orderNumberActive: props.orderNumberActive, orderdetail: '', openreturnurl: props.openreturnurl, openexchangeurl: props.openexchangeurl, inExchange: props.inExchange, inReturn: props.inReturn, type: "clientservice" }))))))));
};
export default OrdersListForReturn;
